import { render, staticRenderFns } from "./KEFooter.vue?vue&type=template&id=febfad6c&scoped=true&"
import script from "./KEFooter.vue?vue&type=script&lang=ts&"
export * from "./KEFooter.vue?vue&type=script&lang=ts&"
import style0 from "./KEFooter.vue?vue&type=style&index=0&id=febfad6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febfad6c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesFooterTopCategories: require('/var/www/packages/theme/components/molecules/FooterTopCategories.vue').default,MoleculesAskAdvice: require('/var/www/packages/theme/components/molecules/AskAdvice.vue').default,MoleculesSignUp: require('/var/www/packages/theme/components/molecules/SignUp.vue').default,MoleculesUsps: require('/var/www/packages/theme/components/molecules/Usps.vue').default,MoleculesFooterQuickLinks: require('/var/www/packages/theme/components/molecules/FooterQuickLinks.vue').default,MoleculesFooterReviews: require('/var/www/packages/theme/components/molecules/FooterReviews.vue').default,MoleculesCopyright: require('/var/www/packages/theme/components/molecules/Copyright.vue').default,MoleculesSocialLinks: require('/var/www/packages/theme/components/molecules/SocialLinks.vue').default,AtomsBusinessLogos: require('/var/www/packages/theme/components/atoms/BusinessLogos.vue').default})
